import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import toTitleCase from '@clearscore/normalize.title-case';
import { timing } from '@clearscore/rainbow.tokens';

import { sizes, themes } from './constants';
import styles from './loader.css';

const Loader = ({ size, animationDuration, isFullPage, theme }) => {
    const inlineStyles = {
        animationDuration,
    };

    const loader = (
        <div
            data-qa="loader"
            className={cx(styles.component, styles[`isSize${toTitleCase(size)}`], {
                [styles[`isTheme${toTitleCase(theme)}`]]: theme,
            })}
            style={inlineStyles}
        >
            <span className={styles.srOnly}>loading</span>
        </div>
    );

    if (isFullPage) {
        return <div className={styles.container}>{loader}</div>;
    }

    return loader;
};

Loader.propTypes = {
    size: PropTypes.oneOf(Object.values(sizes)),
    animationDuration: PropTypes.string,
    isFullPage: PropTypes.bool,
    theme: PropTypes.oneOf(Object.values(themes)),
};

Loader.defaultProps = {
    size: sizes.MEDIUM,
    animationDuration: timing['rnb-timing-normal'],
    isFullPage: false,
    theme: undefined,
};

Loader.sizes = sizes;
Loader.themes = themes;

export default Loader;
